
export interface IPasswordResetHelperProps{
    IsEmailSentSuccessfully: boolean
}

export const InitialPasswordResetHelperProps: IPasswordResetHelperProps = {
    IsEmailSentSuccessfully: false
}